export default "__VITE_ASSET__C9PAFAVz__"